<template lang="pug">
  v-container(fluid fill-height class="ma-0 pa-0")
    v-img(height="100%" width="100%")
      l-map(
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate",
          @click="mapclick",
          ref="myMap"
          :maxZoom="19"
      )
        l-tile-layer(:url="url" :attribution="attribution" :options="layerOptions" :tile-layer-class="tileLayerClass")

        l-marker(
          v-if="selectedTrip == null",
          v-for="m in tripMarkers",
          :key="m.id",
          :lat-lng="m.LatLng",
          :icon="trip_marker"
        )
          l-popup
            v-row(@click="tripSelected(m.Trip)") 
              v-col(cols=2)
                v-icon mdi-directions
              v-col(cols=9)
                span {{ m.Name }}
        l-marker(
          v-if="routeData",
          v-for="m in chargingMarkers",
          :key="m.id",
          :lat-lng="m.LatLng",
          :icon="getIcon(m)"
        )
          l-popup {{ m.Title }}
        l-polyline(
          v-if="routeData",
          :lat-lngs="latLngs",
          :color="colourForTrip(1)"
        )
</template>

<script>
import MapSupport from "../mixins/MapSupport.js";
import EVNav from "../services/api/EVNav.js";
export default {
  name: "Map",
  mixins: [MapSupport],
  data() {
    return {
      routeData: null,
    };
  },
  props: ["selectedTrip", "roadTrips", "chargers"],
  computed: {
    latLngs() {
      let latlngs = [];
      if (this.routeData && this.routeData.routes) {
        for (let p of this.routeData.routes[0].geometry.coordinates) {
          latlngs.push([p[1], p[0]]);
        }
      }
      if (this.$refs.myMap && latlngs.length > 0) {
        this.$refs.myMap.mapObject.fitBounds(latlngs);
      } else {
        if (this.$refs.myMap) this.$refs.myMap.mapObject.setZoom(6);
      }
      return latlngs;
    },
    tripMarkers() {
      let markers = [];
      if (this.roadTrips != null && this.roadTrips) {
        for (let i = 0; i < this.roadTrips.length; i++) {
          let m = {};
          let trip = this.roadTrips[i];
          m.Name = trip.Name;
          m.LatLng = this.getTripLocation(trip);
          m.Trip = trip;
          if (m.LatLng.lat) {
 markers.push(m);
          }
         
        }
      }
      console.log(markers);
      return markers;
    },

    chargingMarkers() {
      let markers = [];
      if (this.routeData != null) {
        for (let ch of this.chargersOnRoute(this.latLngs)) {
          let m = JSON.parse(JSON.stringify(ch));
          //m.LatLng = { lat: m.location[1], lng: m.location[0] };
          markers.push(m);
        }
      }
      console.log(markers);
      return markers;
    },
  },
  methods: {
    tripSelected: function(trip) {
      this.$emit('tripSelected',trip);
    },
    chargersOnRoute: function () {

      let metres = 5 * 1000; //Divert no more than 5km to find a charger
      let routeChargers = [];
      let points = this.getPoints();
      let chargersCopy = JSON.parse(JSON.stringify(this.chargers));

      for (let p of points) {
        for (let c of chargersCopy) {
          c.LatLng = { lat: c.Latitude, lng: c.Longitude };
          if (this.haversineDistance(c.LatLng, p) < metres) {
            routeChargers.push(c);
            chargersCopy = chargersCopy.filter((cc) => cc.ID !== c.ID);
          }
        }
      }
      console.log(routeChargers);
      return routeChargers;
    },
    getPoints() {
      let points = [];
      if (this.latLngs.length > 0) {
        var startPoint = { lat: this.latLngs[0][0], lng: this.latLngs[0][1] };
        points.push(startPoint);
        for (let p of this.latLngs) {
          let pLatLng = { lat: p[0], lng: p[1] };
          if (this.haversineDistance(pLatLng, startPoint) > 500) {
            points.push(pLatLng);
            startPoint = pLatLng;
          }
        }
      }
      return points;
    },
  },
  watch: {
    selectedTrip: {
      immediate: true,
      handler(val) {
        if (val && val.waypoints.length > 0) {
          this.routeData = EVNav.getDirectTrip(val.waypoints).then(
            (response) => (this.routeData = response)
          );
        } else {
          this.routeData = null;
          if(this.$refs.myMap){

            this.$refs.myMap.mapObject.setZoom(6);
          }

        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>